import React from 'react'
import { useTranslation } from 'next-i18next'
import { useAppSelector } from 'src/app/hooks'
import { currencyListSelector } from 'src/features'
import { Currency, Deposit } from 'src/core/models'
import { FormLabels } from 'src/components'
import { getFormatedPrice } from 'src/core/helpers'
interface PropsType {
  deposit: Deposit
}

const DepositAmountColumn = ({ deposit }: PropsType) => {
  const { t } = useTranslation()
  const currencyList = useAppSelector(currencyListSelector)
  const code = currencyList?.find((c: Currency) => c.id === deposit?.currency_token_id)?.code

  const currencyCode = {
    EUR: t('Currency.Euro'),
    USD: t('Currency.Dollars'),
    GBP: t('Currency.Pounds'),
    CLP: t('Currency.CLP')
  }[code] || t('Currency.Euro')

  return (
    <FormLabels
      title={getFormatedPrice(deposit?.total, code)}
      subtitle={currencyCode}
    />
  )
}

export default DepositAmountColumn
